import { Globe } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export function LanguageSwitcher({ compact = false }) {
  const { lang, changeLang } = useLang();
  return (
    <div className={`flex items-center gap-1 rounded-lg border border-slate-800 bg-[#11141A] p-0.5 ${compact ? "" : ""}`} data-testid="language-switcher">
      <Globe className="ml-1 h-3.5 w-3.5 text-slate-500" />
      {["fr", "en"].map((l) => (
        <button
          key={l}
          onClick={() => changeLang(l)}
          data-testid={`lang-${l}`}
          className={`rounded px-1.5 py-0.5 text-[11px] font-bold uppercase transition-colors ${lang === l ? "bg-amber-500 text-black" : "text-slate-400 hover:text-white"}`}>
          {l}
        </button>
      ))}
    </div>
  );
}
